import { EGoalDatapointType } from "motw_core/Goals/GoalDataPoints/EGoalDatapointType";
import * as React from "react";
import { GEPGoalIcon } from "source/app/presentation/MainPanel/Goals/GoalEditor/GoalEditorPanel/Icon/GEPGoalIcon";
import { ShowLinkToIdentityScore } from "source/app/presentation/MainPanel/Goals/GoalEditor/GoalEditorPanel/IdentityScore/ShowLinkToIdentityScore";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { Style } from "source/app/presentation/Shared/Styles/CSS";
import Nameof from "source/app/services/NameOf";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IGoal } from "../../../../../../../../motw_core/Entity/IGoal";
import ChevronPanel from "../../../../Shared/ChevronPanel/ChevronPanel";
import { ISnapshottableComponent } from "../../../../Shared/ISnapshottable/ISnapshottableComponent";
import Render from "../../../../Shared/Render";
import { difficultyRange } from "../../../Dreams/DreamHelpers/DreamHelpers";
import { CanSaveProperty } from "./CanSaveProperty";
import { GEPProps } from "./GEPState/GEPStateProps";
import { GEPStateSnapshot } from "./GEPState/GEPStateSnapshot";
import { PrepareGEPState } from "./GEPState/PrepareGEPState";
import { emptyGEPStateContainer } from "./GEPState/emptyGEPStateContainer";
import { GEPSwitch } from "./GEPSwitch/GEPSwitch";
import { GetGEPInputBox } from "./GetGEPInputBox";
import { GetGEPTextAreaBox } from "./GetGEPTextAreaBox";
import GoalDataPoints from "./GoalDataPoints/GoalDataPoints";
import * as styles from "./GoalEditorPanel.css";
import { GoalVerb } from "./GoalVerb";
import { HandleValueChange } from "./HandleValueChange";
import { ShowNewDaysLeft } from "./ShowNewDaysLeft";
import { StartDate } from "./StartDate/StartDate";

export class GoalEditorPanel
    extends React.PureComponent<GEPProps, GEPStateSnapshot>
    implements ISnapshottableComponent<GEPProps, GEPStateSnapshot>
{
    constructor(props: GEPProps) {
        super(props);
        this.state = {
            currentState: emptyGEPStateContainer,
            previousState: emptyGEPStateContainer,
        };
    }

    componentDidMount() {
        PrepareGEPState(this);
        State.ShareClass(ESharedComponent.GoalEditorPanel, this);
    }

    componentDidUpdate() {
        State.ShareClass(ESharedComponent.GoalEditorPanel, this);
    }

    render() {
        const data = this.state.currentState;

        return (
            <div>
                <ShowLinkToIdentityScore goalId={this.state.currentState.id} />
                {GetGEPInputBox(this, {
                    property: GEPNameProperty,
                    type: "text",
                })}
                <StartDate GEP={this} />
                {GetGEPInputBox(this, {
                    property: Nameof<IGoal>("goalhideuntildayslimit"),
                    type: "number",
                    width: "60px",
                    alternateLabel: `days`,
                    displayBlock: false
                })}
                {GetGEPInputBox(this, {
                    property: Nameof<IGoal>("goalindangerdayslimit"),
                    type: "number",
                    width: "60px",
                    alternateLabel: `to`,
                    displayBlock: false
                })}
                {GetGEPInputBox(this, {
                    property: "weeklyrate",
                    type: "number",
                    width: "175px",
                })}
                <FormSelect
                    id="selectDifficulty"
                    label="Difficulty"
                    width="65px"
                    suggestions={difficultyRange.map((elem) => elem.toString())}
                    onChange={(event: any) =>
                        HandleValueChange(
                            this,
                            event.target.value,
                            "difficulty"
                        )
                    }
                    value={this.state.currentState["difficulty"]}
                />
                <DailyRate weeklyRate={this.state.currentState.weeklyrate} />
                <Render
                    id="showNewDaysLeft"
                    when={!data.isarchived && data.istracking}
                >
                    <ShowNewDaysLeft GEP={this} />
                </Render>
                <GoalVerb GEP={this} data={data} />
                {GetGEPTextAreaBox(this, {
                    property: "notes",
                })}
                <GEPGoalIcon
                    iconName={data.icon}
                    style={styles.goalIcon}
                    onChange={(event: any) =>
                        HandleValueChange(this, event.target.value, "icon")
                    }
                    canSave={CanSaveProperty("icon")}
                    GEP={this}
                />
                <GEPSwitch GEP={this} label="Upper?" targetProperty="isupper" />
                <GEPSwitch
                    GEP={this}
                    label="Tracking"
                    targetProperty="istracking"
                />
                <GEPSwitch
                    GEP={this}
                    label="Requires comment"
                    targetProperty="iscommentrequired"
                />
                <GEPSwitch
                    GEP={this}
                    label="1-time?"
                    targetProperty="is1time"
                />
                <GEPSwitch GEP={this} label="Daily" targetProperty="isdaily" />
                <GEPSwitch
                    GEP={this}
                    label="Archived"
                    targetProperty="isarchived"
                />
                <ChevronPanel id="goalDatapoints" label="Datapoints">
                    <GoalDataPoints
                        goal={this.state.currentState}
                        type={EGoalDatapointType.GoalDatapoint}
                    />
                </ChevronPanel>
                <ChevronPanel id="goalWeeklyRateChanges" label="Rate changes">
                    <GoalDataPoints
                        goal={this.state.currentState}
                        type={EGoalDatapointType.WeeklyRateChange}
                    />
                </ChevronPanel>
                <GEPSwitch
                    GEP={this}
                    label="Resonating"
                    targetProperty="isresonating"
                />
            </div>
        );
    }
}

export default GoalEditorPanel;

const DailyRate = ({ weeklyRate }: { weeklyRate: number }) => {
    const dailyRate = Math.round((weeklyRate / 7) * 100) / 100;

    return (
        <div
            {...Style(`dailyRate`, {
                margin: "5px",
                fontWeight: "bold",
                color: "silver",
            })}
        >{`${dailyRate} / day`}</div>
    );
};

export const GEPNameProperty = "name";
